import * as React from 'react';
import { IconCross } from '@xingternal/icons';
import * as Styled from './bottom-sheet.styles';
export const BottomSheetPrimitive = ({ children, className, closeModal, show, showCloseButton, ...props }) => (React.createElement(Styled.BottomSheet, { className: className, "data-show": show, "data-xds": "BottomSheet", ...props },
    React.createElement(Styled.Wrapper, null,
        children,
        showCloseButton ? (React.createElement(Styled.Close, { icon: IconCross, onClick: closeModal })) : null)));
BottomSheetPrimitive.displayName = 'BottomSheet (Primitive)';
//# sourceMappingURL=bottom-sheet.primitive.js.map